import React from 'react';
import UserBrowser, { User } from './UserBrowser';

interface UserBrowserSidebarProps {
  filters?: {
    hasProfile?: boolean | { value?: boolean; visible?: boolean; locked?: boolean };
    department?: string | { value?: string; visible?: boolean; locked?: boolean };
    employmentType?: 'fullTime' | 'contractor' | 'all' | { value?: 'fullTime' | 'contractor' | 'all'; visible?: boolean; locked?: boolean };
  };
  multiSelect?: boolean;
  onSelectionChange: (users: User[]) => void;
  initialSelection?: User[];
  maxSelections?: number;
  itemsPerPage?: number;
}

const UserBrowserSidebar: React.FC<UserBrowserSidebarProps> = ({
  filters = {},
  multiSelect = true,
  onSelectionChange,
  initialSelection,
  maxSelections,
  itemsPerPage = 5
}) => {
  // Simply wrap the UserBrowser component
  // The UserBrowser already handles all the functionality we need
  return (
    <UserBrowser
      filters={filters}
      multiSelect={multiSelect}
      onSelectionChange={onSelectionChange}
      initialSelection={initialSelection}
      maxSelections={maxSelections}
      itemsPerPage={itemsPerPage}
    />
  );
};


export default UserBrowserSidebar;